require("../tags/registration")
require("../tags/already_register")
require("../tags/confirm_noft")
window.moment = require('moment');
riot.mount('registration')
